module.exports = __webpack_public_path__ + "img/careerone-logo-mint.55e9f6e.svg";